interface UserB2B {
  id: number;
  title: string;
  account: {
    balance: string;
    currency: string;
  };
}

export class UserModel {
  id!: number;
  username!: string;
  email!: string;
  firstName!: Nullable<string>;
  lastName!: Nullable<string>;
  settings!: Record<string, boolean> | never[];
  locale!: Nullable<string>;
  flags!: Record<string, boolean> | never[];
  b2b?: UserB2B;
}

export class User extends UserModel {
  constructor(model: UserModel) {
    super();

    Object.assign(this, model);
  }

  get name() {
    if (this.firstName) {
      let name = this.firstName;

      if (this.lastName) {
        name += ` ${this.lastName}`;
      }

      return name;
    }

    if (this.username) {
      return this.username;
    }

    return this.email;
  }

  isMe(id: number) {
    return this.id === id;
  }
}
